import { BrandConfig } from './types';

/**
 * Lenvoy (lenvoy.co). Palette and type from `lenvoy_design/assets/README.txt`:
 * deep navy #1B2A4A primary, amber #F2A93B accent (sparingly), warm paper
 * #F4F1EA neutral, charcoal #3A3A3A secondary text, Manrope SemiBold wordmark.
 * Green #1E8E5A stays reserved for functional states and is not a brand color here.
 */
export const LENVOY_BRAND: BrandConfig = {
  id: 'lenvoy',
  brandSite: 'lenvoy.co',
  stagingWebHost: 'staging.lenvoy.co',
  name: 'Lenvoy',
  siteTitle: 'Lenvoy Car Rental',
  // As in Lenvoy's Terms of Service and agreements (October 2026).
  legalName: 'Lenvoy LLC',
  supportEmail: 'support@lenvoy.co',
  supportPhone: '(855) 595-5915',
  // Every document here is Lenvoy LLC's own (October 2026), converted from their .docx.
  policyBasePath: '/policies/lenvoy',
  extraPolicies: ['renter-agreement'],
  policyTitles: {
    cancellation: 'Cancellation and Refund Policy',
    'renter-agreement': 'Vehicle Rental Agreement',
  },
  assets: {
    favicon: '/brands/lenvoy/favicon.svg',
    faviconPng: '/brands/lenvoy/favicon-32.png',
    appleTouchIcon: '/brands/lenvoy/apple-touch-icon.png',
    manifest: '/brands/lenvoy/manifest.json',
    notificationIcon: '/brands/lenvoy/icon-192.png',
  },
  copy: {
    heroHeadline: 'Vehicles for the way you work',
    heroSubcopy:
      'Rent dependable cars, SUVs and trucks from Lenvoy and its partner hosts. Clear pricing, flexible pickup, and the protection you choose.',
    about:
      'Lenvoy puts dependable vehicles within reach for people who drive for work and for life. Our fleet covers everyday sedans, roomy SUVs and capable trucks, each inspected and maintained before it reaches you. Pricing is clear, pickup is flexible, and every trip comes with protection options you choose. Whether you need a car for a day, a month or a season, Lenvoy keeps the process simple so you can keep moving.',
    metaDescription:
      'Lenvoy — Vehicles for the way you work. Rent cars, SUVs and trucks with clear pricing, flexible pickup and protection you choose.',
    // No insurer or policyholder is named until Lenvoy confirms its own policy. Add the
    // sentence here, not in the checkout page.
    protectionDescription:
      'Choose a protection plan to protect you in the event of damage to a vehicle during a trip.',
  },
  theme: {
    primary: '#1B2A4A',
    primaryHover: '#142039',
    primaryLight: '#2E4370',
    onPrimary: '#F4F1EA',
    accent: '#F2A93B',
    textPrimary: '#1B2A4A',
    textSecondary: '#5C6270',
    bg: '#FFFFFF',
    bgSecondary: '#F4F1EA',
    bgElevated: '#FFFFFF',
    border: '#E3DDCE',
    fontSans: "'Manrope', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    fontDisplay: "'Manrope', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  },
  showStagingPlaceholderName: false,
};
